import type { BaseStyles } from '../../themes/ThemeTypes';

import colors from './colors';
import fonts from './fonts';

// To be filled in with Utilita theme base styles
const baseTheme: BaseStyles = {
  typography: {
    body: {
      fontFamily: 'Arial, sans-serif',
      fontWeight: fonts.fontWeights.normal,
      fontSize: '16px',
      lineHeight: '20px',
    },
    p: {
      lineHeight: fonts.lineHeights.xl,
      '${max.sm}': {
        fontSize: '14px',
        lineHeight: '18px',
      },
      b: {
        fontWeight: fonts.fontWeights.demi,
      },
    },
    h1: {
      color: colors.dark,
      fontWeight: fonts.fontWeights.demi,
      fontSize: '32px',
      lineHeight: '36px',
      '${max.sm}': {
        textAlign: 'center',
      },
      '${min.sm}': {
        fontSize: '36px',
        lineHeight: '40px',
      },
      '${min.md}': {
        fontSize: '40px',
        lineHeight: '44px',
      },
    },
    h2: {
      fontWeight: fonts.fontWeights.demi,
      color: colors.dark,
      fontSize: '24px',
      lineHeight: '28px',
      '${min.sm}': {
        fontSize: '28px',
        lineHeight: '32px',
      },
      '${min.md}': {
        fontSize: '32px',
        lineHeight: '36px',
      },
    },
    h3: {
      fontWeight: 600,
      color: colors.dark,
      fontSize: '20px',
      lineHeight: '24px',
      '${min.sm}': {
        fontSize: '22px',
        lineHeight: '26px',
      },
      '${min.md}': {
        fontSize: '24px',
        lineHeight: '28px',
      },
    },
    h4: {
      fontWeight: fonts.fontWeights.medium,
      color: colors.dark,
      fontSize: '18px',
      lineHeight: '22px',
    },
    h5: {
      fontSize: '16px',
      fontWeight: 500,
      color: colors.dark,
      lineHeight: '20px',
    },
    a: {
      color: colors.primary,
      textDecoration: 'none',
      cursor: 'pointer',
      lineHeight: '20px',
      '&:hover': {
        color: colors.primaryHover,
      },
    },
  },
};

export default baseTheme;
